import {
  Box,
  IconButton,
  LinearProgress,
  linearProgressClasses,
  Paper,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { OpenInFullOutlined } from "@mui/icons-material";

import useStyles from "./styles";

import { useEffect, useState } from "react";
import dayjs from "dayjs";

import LineChartComponent from "../lineComponent";
import ModalChartHistory from "../modalChartHistory";
const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone");
dayjs.extend(utc);
dayjs.extend(timezone);
const timeZone = "America/Sao_Paulo";

export default function CardGraphComponent(params) {
  const {
    data = [],
    titleGraph,
    loading = false,
    iconColorCard = "green",
    icon: Icon = null,
    nameParamsObject = "value",
    valueCard = 0,
    CustomTooltip = () => {},
    tickFormatter = () => {},
    maxValuebps = null,
    minValuebps = null,
    hideProgress = false,
    getProgressValue = null,
    cardTitleOverrideStyles = {},
    topRightItem = null,
    handleAplicarZoom = () => {},
    isZoomEnabled = false,
    enableHistoryModal = true,
  } = params;
  const [color, setColor] = useState(1);
  const [lastValue, setLastValue] = useState(0);
  const [openModalHistory, setOpenModalHistory] = useState(false);
  const theme = useTheme();
  const styles = useStyles(theme);
  const maxValue =
    Array.isArray(data) && data?.length > 0
      ? Math.max(...data?.map((item) => Number(item?.[nameParamsObject])))
      : null;
  useEffect(() => {
    setLastValue(valueCard);
  }, [valueCard]);
  useEffect(() => {
    setColor(iconColorCard);
  }, [iconColorCard]);
  const normalizeProgress = (value) => {
    if (getProgressValue) {
      return getProgressValue(value);
    }

    const num = Number(value);
    if (isNaN(num)) return 0;
    return Math.max(0, Math.min(100, num));
  };
  return (
    <Paper
      sx={{
        ...styles.paper,
        backgroundColor: theme.palette.background.paper,
      }}
      elevation={theme.palette.mode == "dark" ? 0 : 3}
    >
      {loading && <LinearProgress sx={styles.linearProgress} />}
      <Box sx={styles.containerComponent}>
        <Box sx={styles.headerRow}>
          <Typography sx={styles.cardSubText}>{titleGraph}</Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            {topRightItem && topRightItem}
            {enableHistoryModal && (
              <Tooltip title="Abrir histórico ampliado">
                <IconButton
                  size="small"
                  onClick={() => setOpenModalHistory(true)}
                  sx={{ color: theme.palette.text.secondary }}
                >
                  <OpenInFullOutlined fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        </Box>

        <Box sx={styles.containerGraph}>
          <Box sx={styles.containerCardData}>
            <Box sx={styles.containerCardDataTitle}>
              <Box
                sx={{
                  ...styles.containerIcon,
                  backgroundColor: theme.palette.cardGraphic.graphColor[color],
                }}
              >
                {Icon && <Icon sx={styles.icon} />}
              </Box>
              <Typography
                sx={{
                  ...styles.cardTitle,
                  color: theme.palette.cardGraphic.graphColor[color],
                  ...cardTitleOverrideStyles,
                }}
              >
                {lastValue}
              </Typography>
            </Box>

            {!hideProgress && (
              <LinearProgress
                variant="determinate"
                value={normalizeProgress(parseInt(lastValue, 10))}
                sx={{
                  height: 4,
                  borderRadius: 6,
                  [`&.${linearProgressClasses.colorPrimary}`]: {
                    backgroundColor:
                      theme.palette.cardGraphic.colorPogressLine.dark[color],
                  },
                  [`& .${linearProgressClasses.bar}`]: {
                    borderRadius: 6,
                    backgroundColor:
                      theme.palette.cardGraphic.colorPogressLine.light[color],
                  },
                }}
              />
            )}
          </Box>

          <LineChartComponent
            data={data}
            isZoomEnabled={isZoomEnabled}
            onZoomChange={(range) => {
              // Use .unix() para interpretar o valor como segundos
              const startDate = dayjs.unix(range.start).tz(timeZone);
              const endDate = dayjs.unix(range.end).tz(timeZone);

              handleAplicarZoom(startDate, endDate);
            }}
            maxTicks={10}
            mainColor={theme.palette.cardGraphic.graphColor["green"]}
            mainLineColor={theme.palette.cardGraphic.graphLineColor["green"]}
            maxValuebps={Math.max(maxValue, maxValuebps)}
            minValuebps={minValuebps ? minValuebps : 0}
            yOptions={{ tickFormatter: tickFormatter }}
            customTooltip={CustomTooltip}
            xOptions={{
              tickFormatter: (clock) =>
                dayjs.unix(clock).tz(timeZone).format("DD/MM HH:mm"),
            }}
          />
        </Box>
      </Box>

      {enableHistoryModal && (
        <ModalChartHistory
          open={openModalHistory}
          onClose={() => setOpenModalHistory(false)}
          title={titleGraph}
          icon={Icon}
          color={color}
          initialData={data}
          currentValue={valueCard}
          unit={params?.unit || ""}
          formatValue={params?.tickFormatter}
          maxValuebps={maxValuebps}
          minValuebps={minValuebps}
        />
      )}
    </Paper>
  );
}
